export default "__VITE_ASSET__1167f505__"